import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { SeleteHospitalComponent } from './selete-hospital/selete-hospital.component';
import { MainComponent } from './main/main.component';
import { UploadComponent } from './main/upload/upload.component';
import { HistoryComponent } from './main/history/history.component';
import { HospitalComponent } from './main/hospital/hospital.component';
import { DisplayComponent } from './main/display/display.component';
import { AuthenerGuardsGuard } from '../app/login/guards/authener-guards.guard'
import { TestComponent } from '../app/test/test.component';
import { EmployeeComponent } from './main/mangement/employee/employee.component';
import { PackageComponent } from './main/mangement/package/package.component';
import { HospitalCreateComponent } from './main/mangement/hospital-create/hospital-create.component';
import { ApiComponent } from './main/mangement/api/api.component';
import { HistoryHospitalComponent } from './main/mangement/history-hospital/history-hospital.component';
import { AnnounccmentComponent } from './main/mangement/announccment/announccment.component';


const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'selete-hospital', component: SeleteHospitalComponent, canActivate:[AuthenerGuardsGuard]},
  // { path: 'selete-hospital', component: SeleteHospitalComponent },
  { path: 'main/upload', component: UploadComponent, canActivate:[AuthenerGuardsGuard] },
  // { path: 'main/upload', component: UploadComponent},
  { path: 'main/history', component: HistoryComponent, canActivate:[AuthenerGuardsGuard] },
  { path: 'main/hospital', component: HospitalComponent, canActivate:[AuthenerGuardsGuard] },
  // { path: 'main/history', component: HistoryComponent },
  { path: 'main/display', component: DisplayComponent, canActivate:[AuthenerGuardsGuard] },
  // { path: 'main/display', component: DisplayComponent},
  { path: 'main/mangement/employee', component: EmployeeComponent, canActivate:[AuthenerGuardsGuard]},
  { path: 'main/mangement/package', component: PackageComponent, canActivate:[AuthenerGuardsGuard]},
  { path: 'main/mangement/hospital-create', component: HospitalCreateComponent, canActivate:[AuthenerGuardsGuard]},
  { path: 'main/mangement/api', component: ApiComponent, canActivate:[AuthenerGuardsGuard]},
  { path: 'main/mangement/history-hospital', component: HistoryHospitalComponent, canActivate:[AuthenerGuardsGuard]},
  { path: 'main/mangement/announccment', component: AnnounccmentComponent, canActivate:[AuthenerGuardsGuard]},
  // { path: 'main/mangement/package', component: PackageComponent},
  { path: 'test', component: TestComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes), CommonModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
